import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { checkDetailTicket } from '@/service/ticketService';
import { multiPanelAtom } from '@/state/atom/panelAtom';
import {
    setPanelSelector,
    triggerReloadTicketListByPanelType
} from '@/state/selector/panelSelector';
import { Tooltip, Typography } from '@material-ui/core';
import { S3Image } from 'aws-amplify-react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { getTitle } from './handler/TicketListHandler';
import { I18n } from 'aws-amplify';

export default function DetailTicketListLastMessage(props) {
    const { ticket, setIsLoading, API, getTicketListType, ticketListType } = props;

    const addNewPanel = useSetRecoilState(setPanelSelector);
    const reloadTicketListByPanelType = useSetRecoilState(triggerReloadTicketListByPanelType);
    const [panelList] = useRecoilState(multiPanelAtom);

    const openChatThreadPanel = async (ticketDetail, selectThreadId = null) => {
        // console.log('177259 done openChatThreadPanel', props)
        setIsLoading(true);
        let currentStatusTicket = await checkDetailTicket(API, ticketDetail.id);
        setIsLoading(false);

        if (currentStatusTicket.status === Constant.TICKET_DELETED_STATUS.REMOVED) {
            reloadTicketListByPanelType({
                panelType: getTicketListType()
                    ? getTicketListType()
                    : Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
            });
            return;
        }

        let newPanelChatId = Date.now().toString();
        if (ticketListType.includes('helpdesk')) {
            let helpdeskChatThreadPanel = panelList.find(
                p => p.type === Constant.PANEL_TYPE.HELPDESK_CHATTHREAD
            );
            if (!Utils.isEmptyObject(helpdeskChatThreadPanel)) {
                newPanelChatId = helpdeskChatThreadPanel.id;
            }
        } else {
            let customerChatThreadPanel = panelList.find(
                p => p.type === Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD
            );
            if (!Utils.isEmptyObject(customerChatThreadPanel)) {
                newPanelChatId = customerChatThreadPanel.id;
            }
        }

        const title = getTitle(ticketDetail.settingTitle);
        const panelType =
            ticketListType === 'helpdesk'
                ? Constant.PANEL_TYPE.HELPDESK_CHATTHREAD
                : Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD;
        let openDetailPanelProps = {
            API: props.API,
            panelId: props?.panelId,
            tabId: props?.tabId,
            ticketId: ticketDetail.id,
            ticketListType: ticketListType,
            panelType: panelType,
            history: props?.history
        };
        addNewPanel({
            //update
            type: panelType,
            tabId: ticketDetail.id,
            props: openDetailPanelProps,
            ticketId: ticketDetail.id,
            ticketOutline: title,
            selectThreadId: selectThreadId ? selectThreadId : '',
            isShowAllChatPost: false,
            newPanelId: newPanelChatId,
            openFromType: 'lastMessage',
            startRelatePanelFromPanelId: props?.panelId,
            isEmailTicket: ticketDetail.ticketType === Constant.TICKET_TYPE.EMAIL
        });

        // open ticket detail panel
        let isDraft = ticketDetail.public === Constant.TICKET_PUBLIC.DRAFT;
        setTimeout(async () => {
            await addNewPanel({
                //update
                type: props.ticketListType.includes('helpdesk')
                    ? Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL
                    : Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL,
                tabId: ticketDetail.id,
                props: openDetailPanelProps,
                ticketId: ticketDetail.id,
                ticketOutline: title,
                isDraft: isDraft,
                currentPanelId: newPanelChatId,
                openRelatePanelType: panelType,
                isEmailTicket: ticketDetail.ticketType === Constant.TICKET_TYPE.EMAIL
            });
        }, 1500);
    };
    return (
        <div className="ticket-chat-notice">
            <div className="chat-avatar">
                {Utils.isEmptyString(ticket.lastMessageInfo.shortFullName) && (
                    <Tooltip
                        title={
                            ticket.lastMessage?.userId?.includes('anonymous')
                                ? '未登録カスタマー'
                                : ticket.lastMessageInfo.fullName
                        }
                    >
                        {ticket.lastMessageInfo.avatar === Constant.AVATAR_DEFAULT ? (
                            <img
                                alt=""
                                src={ticket.lastMessageInfo.avatar}
                                className="chat-avatar-frame"
                            />
                        ) : (
                            <div>
                                <S3Image
                                    title={ticket.lastMessageInfo.fullName}
                                    imgKey={ticket.lastMessageInfo.avatar}
                                    className="chat-avatar-frame"
                                />
                            </div>
                        )}
                    </Tooltip>
                )}
                {!Utils.isEmptyString(ticket.lastMessageInfo.shortFullName) && (
                    <Tooltip title={ticket.lastMessageInfo.fullName}>
                        <Typography
                            component="div"
                            variant="subtitle2"
                            className="chat-avatar-frame"
                        >
                            {ticket.lastMessageInfo.shortFullName}
                        </Typography>
                    </Tooltip>
                )}
                {ticket.lastMessageInfo.unreadMessageNumber > 0 && (
                    <span className="msg-unread">
                        {ticket.lastMessageInfo.unreadMessageNumber > 99
                            ? '99+'
                            : ticket.lastMessageInfo.unreadMessageNumber}
                    </span>
                )}
            </div>
            <Typography
                component="div"
                variant="subtitle2"
                className="message"
                onClick={event => openChatThreadPanel(ticket, ticket.lastMessageInfo.chatThreadId)}
            >
                {ticket.ticketType === Constant.TICKET_TYPE.EMAIL
                    ? Utils.unEscapeHtml(Utils.cleanHtml(ticket?.lastMessageInfo?.message))
                    : ticket.lastMessageInfo.message}
            </Typography>
            {{...ticket}?.hasUnsentMessage && (
                <div className="chat-avatar">
                    <Tooltip title={I18n.get('UN-SENT-MESSAGE-EXIST')} placement="top-center">
                        <img
                            alt=""
                            src={'/assets/image/exclamation-point.svg'}
                            className="chat-avatar-frame"
                        />
                    </Tooltip>
                </div>
            )}
        </div>
    );
}
